import { Box, Collapse, Typography } from '@mui/material';
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

/**
 * 훈련 상세 공통 접이식 섹션
 * 힌트, 정답 확인 패널 등에서 사용
 */
const TrainingDetailCollapsibleSection = ({
  title,
  expanded,
  onToggle,
  children,
  showBorderTop = false,
  flex = false,
}) => (
  <Box sx={flex ? { flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' } : {}}>
    <Box
      sx={{
        p: 1.5,
        bgcolor: '#f5f5f5',
        ...(showBorderTop && { borderTop: '1px solid #e0e0e0' }),
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={onToggle}
    >
      <Typography variant="body2" fontWeight={600}>
        {title}
      </Typography>
      {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
    </Box>
    <Collapse in={expanded} sx={flex ? { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } : {}}>
      {children}
    </Collapse>
  </Box>
);

export default TrainingDetailCollapsibleSection;
